import React from 'react';
import { TreeRenderer } from './TreeRenderer';

export const HeapRenderer = ({ heap, sourceArray, pointers, memory, isLight, textColor, mutedText }) => {
  if (!heap || (heap.length === 0 && (!sourceArray || sourceArray.length === 0))) {
    return (
      <div style={{ padding: '20px', textAlign: 'center', color: mutedText, fontSize: '13px', fontStyle: 'italic' }}>
        Empty Heap
      </div>
    );
  }

  // Convert array heap to tree structure for TreeRenderer
  // Root at 0, children at 2i+1, 2i+2
  const nodes = {};
  const heapArray = Array.isArray(heap) ? heap : [];
  heapArray.forEach((val, i) => {
    const leftIdx = 2 * i + 1;
    const rightIdx = 2 * i + 2;
    nodes[String(i)] = {
      val,
      left: leftIdx < heapArray.length ? String(leftIdx) : undefined,
      right: rightIdx < heapArray.length ? String(rightIdx) : undefined,
    };
  });

  const activeIndices = (pointers || []).map(p => typeof p === 'object' ? p.index : p);

  return (
    <div style={{ padding: '10px 0', display: 'flex', flexDirection: 'column', gap: '20px' }}>
      {/* ─── SOURCE ARRAY (Context) ─── */}
      {sourceArray && sourceArray.length > 0 && (
        <div style={{ marginBottom: '8px' }}>
          <div style={{ fontSize: '9px', fontWeight: 900, color: mutedText, letterSpacing: '0.5px', marginBottom: '6px', textTransform: 'uppercase', opacity: 0.7 }}>
            Input Array:
          </div>
          <div style={{ display: 'flex', gap: '4px', overflowX: 'auto', paddingBottom: '4px' }}>
            {sourceArray.map((val, idx) => {
              const isActive = activeIndices.includes(idx);
              return (
                <div
                  key={idx}
                  style={{
                    minWidth: '24px',
                    height: '24px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '4px',
                    background: isActive 
                      ? (isLight ? '#dbeafe' : '#1e3a8a') 
                      : (isLight ? '#f1f5f9' : '#1a1a1e'),
                    border: `1px solid ${isActive ? '#3b82f6' : (isLight ? '#e2e8f0' : '#2d2d30')}`,
                    color: isActive ? '#3b82f6' : textColor,
                    fontSize: '11px',
                    fontWeight: isActive ? 700 : 400,
                    transition: 'all 0.2s',
                    position: 'relative'
                  }}
                >
                  {val}
                  {isActive && (
                    <div style={{ 
                      position: 'absolute', 
                      bottom: '-6px', 
                      left: '50%', 
                      transform: 'translateX(-50%)', 
                      width: '4px', 
                      height: '4px', 
                      borderRadius: '50%', 
                      background: '#3b82f6' 
                    }} />
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* ─── HEAP TREE (Primary Data Structure) ─── */}
      <div>
        <div style={{ fontSize: '9px', fontWeight: 900, color: mutedText, letterSpacing: '0.5px', marginBottom: '12px', textTransform: 'uppercase', opacity: 0.7 }}>
          Current Heap (Min-Heap):
        </div>
        <TreeRenderer
          tree={nodes}
          rootId="0"
          memory={memory}
          isLight={isLight}
          textColor={textColor}
        />
        <div style={{
          marginTop: '16px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '4px',
          fontSize: '10px',
          color: mutedText,
          fontWeight: 600
        }}>
          <div style={{ width: '8px', height: '8px', borderRadius: '2px', border: `1px solid ${mutedText}` }} />
          <span>ARRAY REPRESENTATION: {JSON.stringify(heapArray)}</span>
        </div>
      </div>
    </div>
  );
};
